module.exports = __webpack_public_path__ + "static/media/leftDecrementArrow.b1ffe9be.svg";